import * as Yup from "yup";
export const validateSchema = Yup.object().shape({
  oldPassword: Yup.string()
    .required("Old password is required")
    .min(8, "Password must contains at least 8 characters")
    .max(255, "Password require maximum of 255 characters"),
  newPassword: Yup.string()
    .required("New password is required")
    .min(8, "Password must contains at least 8 characters")
    .matches(
      /^(?=.*[a-z])/,
      "Password must contains at least 1 lowercase character"
    )
    .matches(
      /^(?=.*[A-Z])/,
      "Password must contains at least 1 uppercase character"
    )
    .matches(
      /^(?=.*[0-9])/,
      "Password must contains at least 1 digit character"
    )
    .matches(
      /^(?=.*[!@#$%^&*])/,
      "Password must contains at least 1 special character (!@#$%^&*)"
    )
    .max(255, "Password require maximum of 255 characters")
    .test(
      "oldPassword",
      "New password and old password must not be the same",
      function (value) {
        return this.parent.oldPassword !== value;
      }
    ),
  confirmPassword: Yup.string()
    .required("You need to confirm your new password")
    .oneOf([Yup.ref("newPassword")], "Your passwords do not match."),
});
export const initialValues = {
  oldPassword: "",
  newPassword: "",
  confirmPassword: "",
};
